export default __webpack_public_path__ + "static/project-slide-4-1248-765-8888d7030d3ae6411cba4b1561a3976d.jpg";